// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuButton_container__3zd3T","button":"MenuButton_button__8NhCz","clear":"MenuButton_clear__Wvjh5"};